import VueI18n from "@/libs/i18n"
// responsive: {
//   rules: [
//     {
//       condition: {
//         maxWidth: 1440,
//         maxHeight: 1440
//       }
//     }
//   ]
// },
const options = {
  chart: {
    type: 'spline'
},
title: {
    text: 'Atendimentos'
},

xAxis: {
    categories: []
},
yAxis: {
    title: {
        text: 'Total'
    }
},
plotOptions: {
    line: {
        dataLabels: {
            enabled: true
        },
        enableMouseTracking: false
    }
},
series: []
}

export default options
